import { render, staticRenderFns } from "./orgDetails.vue?vue&type=template&id=449fb2a1&scoped=true&"
import script from "./orgDetails.vue?vue&type=script&lang=js&"
export * from "./orgDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449fb2a1",
  null
  
)

export default component.exports